// BLOKAS 1 TimeInterval.tsx: IMPORT STATEMENTS
import React from 'react';
import { cn } from '../../utils/cn';

// BLOKAS 2 TimeInterval.tsx: INTERFACE DEFINITION
interface TimeIntervalProps {
  intervals: string[];
  selectedInterval: string;
  onIntervalChange: (interval: string) => void;
}

// BLOKAS 3 TimeInterval.tsx: COMPONENT DEFINITION
export const TimeInterval: React.FC<TimeIntervalProps> = ({
  intervals,
  selectedInterval,
  onIntervalChange
}) => {
  console.log(`🔧 [BLOKAS 3 TimeInterval.tsx] Komponentas inicijuotas`);
  console.log(`   [SUB-BLOKAS 3.1 TimeInterval.tsx] Gauti intervalai: ${intervals.join(', ')}`);
  console.log(`   [SUB-BLOKAS 3.2 TimeInterval.tsx] Pasirinktas intervalas: ${selectedInterval}`);

  // SUB-BLOKAS 3.3 TimeInterval.tsx: INTERVAL SELECTION HANDLER
  const handleIntervalSelect = (interval: string) => {
    console.log(`   [SUB-BLOKAS 3.3 TimeInterval.tsx] Pasirinktas naujas intervalas: ${interval}`);
    console.log(`   [SUB-BLOKAS 3.4 TimeInterval.tsx] Iškviečiama onIntervalChange funkcija`);
    onIntervalChange(interval);
  };

  // SUB-BLOKAS 3.5 TimeInterval.tsx: JSX RENDERING
  console.log(`   [SUB-BLOKAS 3.5 TimeInterval.tsx] Pradedamas JSX renderinimas`);
  
  return (
    <div className="grid grid-cols-4 md:grid-cols-8 gap-2">
      {intervals.map((interval, index) => {
        console.log(`   [SUB-BLOKAS 3.6.${index + 1} TimeInterval.tsx] Renderinamas intervalo mygtukas: ${interval}`);
        
        return (
          <button
            key={interval}
            onClick={() => {
              console.log(`   [SUB-BLOKAS 3.7.${index + 1} TimeInterval.tsx] Mygtukas "${interval}" paspaustas`);
              handleIntervalSelect(interval);
            }}
            className={cn(
              "px-3 py-2 text-sm font-medium rounded-lg transition-colors",
              selectedInterval === interval
                ? "bg-blue-500 text-white"
                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
            )}
          >
            {interval}
          </button>
        );
      })}
    </div>
  );
};

// BLOKAS 4 TimeInterval.tsx: COMPONENT DEFAULT EXPORT
console.log(`✅ [BLOKAS 4 TimeInterval.tsx] Komponentas TimeInterval eksportuotas`);
export default TimeInterval;